<div class="bn-transaction-signing-widget__block">


  <section class="payment-from"
           [formGroup]="form">

    <div class="bn-transaction-signing-widget__content">

      <div class="bn-transaction-signing-widget__content__inner">
        <p class="mb-0"
           i18n="@@bb-sms-otp-signing.confirm-identity">For your security, we need to confirm your identity.</p>
        <p i18n="@@bb-sms-otp-signing.prefer-to-receive-code">Select where you prefer to receive your code:</p>

        <div>
          <bn-otp-error-msg [displayError]="data?.error" [errorCode]="data?.error"></bn-otp-error-msg>
        </div>

        <bb-input-radio-group-ui
          [preselect]="true"
          data-role="radio-group"
          formControlName="method"
          i18n-label="Schedule ending section name|Label for the section containing inputs that determine way of ending of the schedule@@bb-schedule-ui.label.ending"
        >

        <bb-input-radio-ui
         *ngIf="data?.sms"
         value="sms"
         [labelTemplate]="radioTemplate"
         [labelTemplateContext]="data.sms"
        >
        </bb-input-radio-ui>

          <bb-input-radio-ui
            *ngIf="data?.email"
            value="email"
            [labelTemplate]="radioTemplate"
            [labelTemplateContext]="data.email"
          ></bb-input-radio-ui>

        </bb-input-radio-group-ui>

        <ng-template #radioTemplate let-value="labelTemplateContext">
            <span class="bb-payment-credit-card-subtitle">
              {{value}}
            </span>
        </ng-template>
      </div>

    </div>

    <hr />
    <div class="bb-button-bar">
      <button bbButton
              data-role="ts-sms-otp-complete"
              class="bb-button-bar__button"
              color="primary"
              i18n="@@bb-oob-select-device-signing.complete"
              (click)="onSelect()">
        Continue
      </button>
      <button bbButton
              data-role="ts-sms-otp-cancel"
              class="bb-button-bar__button"
              color="secondary"
              i18n="@@contact-manager.banesco-form.cancel"
              (click)="onCancel()">
        Cancel
      </button>
    </div>
  </section>
</div>
